import { gotoNodeWithoutBrowserKnowing } from './broadcast-helper.js';

export function initBrowserHistoryEvents(dispatch) {
  window.onpopstate = (e) => {
    gotoNodeWithoutBrowserKnowing(e.state, dispatch);
  };
}

export function setBrowserUrl(idPlant) {
  window.history.pushState(idPlant, window.history.length + '', '?anleggsid=' + idPlant);
}



/** WEBPACK FOOTER **
 ** app/components/common/browser-history.js
 **/